import React from 'react';
import { useState, useEffect } from 'react';
// material
import {
    Table,
    TableBody,
    TableContainer,
    Pagination,
    Box,
    Typography,
    TableCell,
    TableRow
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import KioskTableRow from './tableRow';
import CommonTableHead from '../../foodVendor/reports/commonTableHead.js'
import Scrollbar from '../../Scrollbar'
import { getKioskBookingDetailsWatcher } from '../../../redux/actionCreators/kiosk';

export const TABLE_HEAD = [
    { id: 'EmployeeName', label: 'Employee Name', alignRight: false, title: 'Employee Name', field: 'cEmployeeName' },
    { id: 'MenuName', label: 'Menu Name', alignRight: false, title: 'Menu Name', field: 'cMenuName' },
    { id: 'OrderDate', label: 'OrderDate', alignRight: false, title: 'OrderDate', field: 'dOrderDate' },
    { id: 'Quantity', label: 'Quantity', alignRight: false, title: 'Quantity', field: 'nQuantity' },
    { id: 'TotalRate', label: 'TotalRate', alignRight: false, title: 'TotalRate', field: 'TotalRate' },
    { id: 'KioskStatus', label: 'Status', alignRight: false, title: 'Status', field: 'kioskStatus' },
    // { id: 'action', label: 'Action', alignRight: false },
];


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const KioskTable = ({ searchVal, searchText, page, setPage  }) => {

    const { KioskRoleReducers: { kioskDashboardList } } = useSelector((state) => state)

    let firstIndex = 0;

    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [action] = useState(true)
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        let data = {
            "ACTION": "getKioskBookingDetails"
        }
        dispatch(getKioskBookingDetailsWatcher(data))
    }, [dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const tableData = searchText ? searchVal : kioskDashboardList
    const filteredData = applySortFilter(tableData, getComparator(order, orderBy));
    const isUserNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{overflow:'unset'}} >
                        <Table>
                            <CommonTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                onRequestSort={handleRequestSort}
                                action={action}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((f, i) => {
                                        return (
                                            <KioskTableRow key={f.nID} rowData={f} index={i} />
                                        )
                                    })}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default KioskTable;